const CLERK_STEP_BUCKETS = [
  { maxMs: 100, label: "lt100ms" },
  { maxMs: 1_000, label: "100ms-1s" },
  { maxMs: 10_000, label: "1s-10s" },
] as const;

export const getClerkStepBucket = (durationMs: number) =>
  CLERK_STEP_BUCKETS.find((bucket) => durationMs < bucket.maxMs)?.label ?? "gte10s";
